module.exports = __webpack_public_path__ + "static/media/closeButton.7c5860a3.png";